import { TypographyStylesProvider } from '@mantine/core'
import type { FC } from 'react'

type CustomHTMLProps = {
  content: string
}

export const CustomHTML: FC<CustomHTMLProps> = ({ content }) => {
  return (
    <TypographyStylesProvider>
      <div
        // biome-ignore lint/security/noDangerouslySetInnerHtml: <explanation>
        dangerouslySetInnerHTML={{
          __html: content,
        }}
        style={{ wordBreak: 'break-all' }}
      />
    </TypographyStylesProvider>
  )
}
